export const FINANCE_PERIODS = [
  { id: "mes", label: "Este Mês", sub: "Março/2026" },
  { id: "trimestre", label: "Último Trimestre", sub: "Jan–Mar/2026" },
  { id: "ano", label: "Ano 2026", sub: "Acumulado" },
];

// Multiplicadores para simular períodos diferentes sobre a base mensal
export const PERIOD_MULTIPLIER = {
  mes: 1,
  trimestre: 2.9,
  ano: 11.4,
};

export const FINANCE_BASE = {
  faturamentoBruto: 114500,
  repasses: 34350,
  custos: 12150,
  lucroLiquido: 68000,
  margem: 59.3,
  previsaoCaixa: 82000,
  faturamentoVariacao: 14,
};

export const MONTHLY_GOAL = 130000;

export const INITIAL_REPASSES = [
  {
    id: "carlos",
    doctor: "Dr. Carlos Silva",
    specialty: "Cardiologia",
    avatar:
      "https://images.unsplash.com/photo-1645066928295-2506defde470?crop=entropy&cs=srgb&fm=jpg&q=85&w=128&h=128&fit=crop",
    atendimentos: 84,
    producaoBruta: 61600,
    taxa: 30,
    valorLiquido: 18500,
    status: "pronto",
  },
  {
    id: "mariana",
    doctor: "Dra. Mariana Souza",
    specialty: "Dermatologia",
    avatar:
      "https://images.unsplash.com/photo-1659353888906-adb3e0041693?crop=entropy&cs=srgb&fm=jpg&q=85&w=128&h=128&fit=crop",
    atendimentos: 72,
    producaoBruta: 52833,
    taxa: 30,
    valorLiquido: 15850,
    status: "processando",
  },
];

export const REPASSE_STATUS = {
  pronto: { label: "Pronto para liberação", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200/70", dot: "bg-emerald-500" },
  processando: { label: "Processando", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200/70", dot: "bg-amber-500" },
  pago: { label: "Pago via Pix", bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200", dot: "bg-slate-400" },
};

export const MONTHLY_SERIES = [
  { mes: "Out", faturamento: 92000, lucro: 51000 },
  { mes: "Nov", faturamento: 98500, lucro: 55200 },
  { mes: "Dez", faturamento: 105000, lucro: 60100 },
  { mes: "Jan", faturamento: 100400, lucro: 58000 },
  { mes: "Fev", faturamento: 108900, lucro: 63500 },
  { mes: "Mar", faturamento: 114500, lucro: 68000 },
];

export const CONVENIO_DATA = [
  { id: "particular", name: "Particular", volume: 30, margem: 68, faturamento: 34350, color: "#10b981" },
  { id: "unimed", name: "Unimed", volume: 55, margem: 46, faturamento: 62975, color: "#f43f5e" },
  { id: "bradesco", name: "Bradesco Saúde", volume: 10, margem: 54, faturamento: 11450, color: "#3b82f6" },
  { id: "sulamerica", name: "SulAmérica", volume: 5, margem: 51, faturamento: 5725, color: "#6366f1" },
];

export const CFO_INSIGHTS = [
  {
    id: 1,
    type: "alert",
    title: "Concentração de Convênio",
    text: "O Convênio Unimed representa 55% do volume, mas sua margem líquida é 22% menor que os atendimentos Particulares.",
    cta: "Ajustar Estratégia",
  },
  {
    id: 2,
    type: "healthy",
    title: "Fluxo de Caixa Saudável",
    text: "Projeção de recebíveis cobre todas as contas dos próximos 45 dias com folga de 30%.",
    cta: "Ver Detalhes",
  },
];

export const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export const formatCompactBRL = (v) =>
  "R$ " +
  new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(Math.round(v || 0));
